import { Dispatch, SetStateAction, useRef, useState } from 'react'

export function useReactiveState<S>(
  initialStateFactory: () => S,
  dependencies: unknown[],
): [S, Dispatch<SetStateAction<S>>] {
  const prevDependencies = useRef(dependencies)
  const [internalState, setInternalState] = useState(initialStateFactory)

  if (dependencies.some((dependency, index) => !Object.is(dependency, prevDependencies.current[index]))) {
    setInternalState(initialStateFactory)
    prevDependencies.current = dependencies
  }

  return [internalState, setInternalState]
}
